export default "__VITE_ASSET__C4NF1wlf__"